import React, { useState } from 'react';
import { User, FileText, Image, Shield, CheckCircle } from 'lucide-react';
import { useFadeIn } from '../hooks/useFadeIn';
import './FlexibleDesignSection.css';

interface FlexibleDesignSectionProps {
  onLoginClick?: () => void;
  onProductsClick?: () => void;
}

const FlexibleDesignSection: React.FC<FlexibleDesignSectionProps> = ({ onLoginClick, onProductsClick }) => {
  const [activeStep, setActiveStep] = useState<number | null>(null);
  const headerFadeIn = useFadeIn({ delay: 0.1 });
  const flowFadeIn = useFadeIn({ delay: 0.2 });
  const ctaFadeIn = useFadeIn({ delay: 0.3 });

  const steps = [
    { id: 1, label: 'Profile Intake', icon: User },
    { id: 2, label: 'Text Signals', icon: FileText },
    { id: 3, label: 'Image Signals', icon: Image },
    { id: 4, label: 'Risk Policy', icon: Shield },
    { id: 5, label: 'Final Decision', icon: CheckCircle },
  ];

  return (
    <section className="flexible-design-section landing-section">
      <div className="flexible-container landing-container">
        <div 
          ref={headerFadeIn.ref} 
          className={`flexible-header ${headerFadeIn.isVisible ? 'fade-in-hero' : ''}`}
          style={{ animationDelay: `${headerFadeIn.delay}s` } as React.CSSProperties}
        >
          <h2 className="flexible-title">Flexible Moderation Workflow</h2>
          <p className="flexible-subtitle">
            Configure a custom workflow that matches your moderation policy and approval process.
          </p>
        </div>

        <div 
          ref={flowFadeIn.ref} 
          className={`flow-diagram ${flowFadeIn.isVisible ? 'fade-in-hero' : ''}`}
          style={{ animationDelay: `${flowFadeIn.delay}s` } as React.CSSProperties}
        >
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <React.Fragment key={step.id}>
                <div
                  className={`flow-node ${activeStep === step.id ? 'active' : ''}`}
                  onMouseEnter={() => setActiveStep(step.id)}
                  onMouseLeave={() => setActiveStep(null)}
                >
                  <div className="flow-node-icon">
                    <IconComponent size={20} />
                  </div>
                  <div className="flow-node-label">{step.label}</div>
                </div>
                {index < steps.length - 1 && <span className="flow-arrow">→</span>}
              </React.Fragment>
            );
          })}
        </div>

        <div 
          ref={ctaFadeIn.ref} 
          className={`flexible-cta ${ctaFadeIn.isVisible ? 'fade-in-hero' : ''}`}
          style={{ animationDelay: `${ctaFadeIn.delay}s` } as React.CSSProperties}
        >
          <button className="landing-cta-secondary explore-btn" onClick={onProductsClick || onLoginClick}>
            Explore the Dashboard Flow
          </button>
        </div>
      </div>
    </section>
  );
};

export default FlexibleDesignSection;

